module.exports = __webpack_public_path__ + "static/media/bitmap.d3c496e1.jpg";